import { computed, makeObservable } from 'mobx';
import { BaseUiStore } from './base.ui.store';
import { AgenturListUiStore, } from './agt.list.ui.store';
import { IAgtFilterable } from './agt.list.filter.ui.store';


export class BaseAgenturListUiStore<T extends IAgtFilterable> extends BaseUiStore<T> {
	agenturListUiStore: AgenturListUiStore;

	constructor(agenturListUiStore: AgenturListUiStore) {
		super();
		makeObservable(this);
		this.agenturListUiStore = agenturListUiStore;
	}

	/**
	 * Apply both base agency filters and VM-specific filters
	 * This implements the two-step filtering pattern used across the application
	 */
	applyFilter(items: T[]): T[] {
		// Step 1: Apply base agency filters
		let filteredItems = this.agenturListUiStore.applyFilterOnAgt(items) as T[];
		// Step 2: Apply VM-specific filters
		filteredItems = this.agenturListUiStore.currentFilter.applyVmFilter(filteredItems) as T[];
		return filteredItems;
	}


	@computed
	get serverSideVmFilters(): string[] {

		return this.agenturListUiStore.currentFilter.sserverSideVmFilters;
	}

	@computed
	get serverSideAgtFilters(): string[] {
		if (this.agenturListUiStore.filteredAgtIds.length === 0) {
			return []; // No agencies match the filter, return a condition that matches nothing
		}
		return ['a.vtnr_id IN (' + this.agenturListUiStore.filteredAgtIds.join(',') + ')'];

	}
}
